import { AppThunk } from "../states/generateStore";
import slice from "../states/loading/slice";
import { 
    downloadFileFromPath
    , generateQuote
    , saveAndSendPdf
    , suiteCrmUrl
    , sendSMS
} from "./constants";
import snackBarSlice from '../states/snackbar/slice';
import shellSlice from '../states/shell/slice';
import { generateFileName, savePdfFromUrl } from "../helpers/fileHelper";
import { wait } from "../helpers/dateTimeHelper";

const onGenerateQuote = (value: any): AppThunk =>
    async (dispatch, getStore) => {
        try {
            dispatch(slice.actions.updateLoading({isOpen: true, message: 'Quote is being prepared please wait'}));
            // wait
            await wait(500);

            let formData = new FormData();
            formData.append('daikin_data', JSON.stringify(value));

            let response = await fetch(suiteCrmUrl.concat(generateQuote),
                { 
                method: 'POST',
                body: formData
                }
            );
            let result = await response.json();

            if (result) {
                const quoteId = result.quoteData?.quote_id;

                // set Quote number
                dispatch(shellSlice.actions.updateQuoteData({id: result.quoteData?.quote_id, number: result.quoteData?.quote_number}));
                
                // ---------------- Generate PDF ---------------- //
                dispatch(slice.actions.updateLoading({isOpen: true, message: 'Generating PDF...'}));
                // save and send pdf
                const fileName = generateFileName(value, result.quoteData?.quote_number);
                formData = new FormData();
                formData.append('uid', quoteId);
                formData.append('templateID', '4fbfbfa6-0bc9-3dbb-0d5e-57ce330802c5');
                formData.append('preInstallPhotos', result.quoteData?.pre_install);
                formData.append('module', 'AOS_Quotes');
                formData.append('fileName', fileName);
                formData.append('productChoice', value.product_choice);
                formData.append('scope_pdf', value.scope_pdf ? value.scope_pdf : 'no');

                response = await fetch(suiteCrmUrl.concat(saveAndSendPdf),
                    { 
                    method: 'POST',
                    body: formData
                    }
                );
                result = await response.json();

                if (result) {
                    // success
                    if (result.code === 0) {
                        // update state
                        dispatch(shellSlice.actions.updateCurrentStep(4));
                        dispatch(shellSlice.actions.updateDoneStep(4));
                        // download pdf
                        savePdfFromUrl(suiteCrmUrl.concat(downloadFileFromPath), result.content, fileName);

                        // send sms
                        if (value.send_sms && value.send_sms === 'yes') {
                            formData = new FormData();
                            formData.append('phone_number', value.phone_number);
                            formData.append('body', value.sms_template);
                            formData.append('file_path', result.content);
                            formData.append('first_name', value.first_name);
            
                            fetch(suiteCrmUrl.concat(sendSMS),
                                { 
                                method: 'POST',
                                body: formData
                                }
                            );
                        }
                    } else {
                        // show error
                        dispatch(snackBarSlice.actions.updateAlert({message: result.message, severity: "error"}));
                        dispatch(snackBarSlice.actions.updateSnackBar(true));
                    }
                    // hide loading
                    dispatch(slice.actions.updateLoading({isOpen: false, message: 'Generated Quote'}));
                } else {
                    // show warning
                    dispatch(snackBarSlice.actions.updateAlert({message: "Unable to create and send PDF", severity: "warning"}));
                    dispatch(snackBarSlice.actions.updateSnackBar(true));
                }

                // success
                dispatch(snackBarSlice.actions.updateAlert({message: "Generated Quote", severity: "success"}));
                dispatch(snackBarSlice.actions.updateSnackBar(true));
            } else {
                // show warning
                dispatch(snackBarSlice.actions.updateAlert({message: "Unable to create Quote", severity: "warning"}));
                dispatch(snackBarSlice.actions.updateSnackBar(true));
            }
        } catch (err) {
            console.log(err);
            // hide loading
            dispatch(slice.actions.updateLoading({isOpen: false, message: 'Generated Quote'}));
            dispatch(snackBarSlice.actions.updateAlert({message: "Generated Quote", severity: "success"}));
            // show error
            dispatch(snackBarSlice.actions.updateAlert({message: "onGenerateQuote: Can not get data from Server", severity: "error"}));
            dispatch(snackBarSlice.actions.updateSnackBar(true));
        }
    }
export default onGenerateQuote;